import React from "react";
import SEOLandingPage from "./SEOLandingPage";

const SqlRunnerAndroid: React.FC = () => (
  <SEOLandingPage
    title="SQL Runner for Android — Execute SQL Queries on Mobile | Cosmovex"
    metaDescription="Run SQL queries on Android with SQLVEdit. Write and execute SQL against SQLite databases on your phone. Supports SELECT, INSERT, UPDATE, DELETE, and schema operations."
    ogTitle="SQL Runner for Android — SQLVEdit SQL Editor"
    h1="SQL Runner for Android"
    intro="Write SQL, run it, see results. SQLVEdit gives you a proper SQL execution environment on Android — query SQLite databases without needing a desktop database client."
    paragraphs={[
      "SQL runners on desktop are everywhere — DBeaver, TablePlus, DataGrip — but on mobile, the options have historically been poor. SQLVEdit fills that gap with a SQL editor built specifically for Android that actually understands SQL syntax and executes queries against real SQLite databases.",
      "The editor supports the full SQLite SQL dialect. Read operations like SELECT with WHERE, GROUP BY, ORDER BY, and JOIN work exactly as expected. Write operations — INSERT, UPDATE, DELETE — execute with a confirmation step and show you the rows affected. DDL operations like CREATE TABLE, ALTER TABLE, and DROP TABLE are supported too.",
      "Query results are displayed in a scrollable, paginated table with proper column headers. Long text values expand on tap. NULL values are visually distinct from empty strings. The result view is designed to be readable on a phone screen without requiring you to scroll horizontally for every column.",
      "For developers, SQLVEdit is useful during debugging sessions. Export a copy of your app's database, open it in SQLVEdit, run queries to inspect the state, and verify that your app logic is writing what you expect. It's faster than adding log statements and rebuilding.",
    ]}
    features={[
      "Full SQLite SQL dialect support",
      "SELECT with WHERE, JOIN, GROUP BY, ORDER BY",
      "INSERT, UPDATE, DELETE with row count feedback",
      "CREATE, ALTER, DROP table operations",
      "Paginated results table with sortable columns",
      "Query history to replay past statements",
      "Syntax highlighting and bracket matching",
      "Multiple queries in one session",
      "Export results to CSV or share as text",
      "Runs entirely offline on your device",
    ]}
    playStoreUrl="https://play.google.com/store/apps/details?id=com.cosmovex.sqlvedit"
    icon="/images/sqlvedit.png"
    appName="SQLVEdit"
    accentColor="#A8720E"
    canonicalPath="/sql-runner-android"
  />
);

export default SqlRunnerAndroid;
